
    var riot = require('riot')
    //src: starling/src/tags/new-perspective-autocomplete.html
riot.tag2('new-perspective-autocomplete',
  '<div ref="main" class="perspective-autocomplete" riot-style="{this.autocompleteStyle()}"> <div class="autocomplete-header"> cards in map </div> <div class="autocomplete-row focusable {this.selectedItem == index ? \'selected\' : \'\'}" each="{result, index in autocompleteResults}" onmousedown="{this.handleUpdatePerspectivePoint}" onmouseover="{this.handleMouseoverResult.bind(null,result,index)}" onmouseleave="{this.handleMouseleaveResult.bind(null,result,index)}"> <span class="autocomplete-result-title">{result.title}</span> </div> </div>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var _perspectivesUi = require('lib/perspectives-ui');

var _perspectiveCreationUi = require('lib/perspective-creation-ui');

var _searchUi = require('lib/search-ui');

this.canvas = this.opts.canvas;
this.canvas.perspectiveAutocomplete = this;
this.autocompleteResults = [];
this.selectedItem = -1;

this.summon = function (_ref) {
  var perspective = _ref.perspective,
      element = _ref.element,
      done = _ref.done;

  _this.perspective = perspective;
  _this.callback = done;
  _this.spawnedFromElement = element;
  _this.reposition();
};

this.reposition = function () {
  if (!_this.spawnedFromElement) {
    _this.hide();
    return;
  }
  var rect = _this.spawnedFromElement.getBoundingClientRect();
  var left = rect.left;
  var bottom = rect.bottom;
  _this.refs.main.style.top = bottom + 'px';
  _this.refs.main.style.left = left + 'px';
};

this.hide = function () {
  _this.clearResults();
  _this.perspective = null;
  _this.callback = null;
  _this.refs.main.style.display = 'none';
};

this.clearResults = function () {
  _this.selectedItem = -1;
  _this.autocompleteResults = [];
  _this.update();
};

this.incrementSelectedResult = function (diff) {
  if (_this.selectedItem + diff < -1) {
    _this.selectedItem = -1;
  } else if (_this.selectedItem + diff >= _this.autocompleteResults.length) {
    _this.selectedItem = _this.autocompleteResults.length - 1;
  } else {
    _this.selectedItem += diff;
  }
  _perspectiveCreationUi.pcui.highlightSelectedResultNode(_this.getSelectedResult());
};

this.getSelectedResult = function () {
  if (_this.selectedItem < 0) {
    return;
  }
  if (_this.autocompleteResults) {
    return _this.autocompleteResults[_this.selectedItem];
  }
};

this.autocompleteStyle = function () {
  if (_this.autocompleteResults.length > 0 && _this.spawnedFromElement) {
    var rect = _this.spawnedFromElement.getBoundingClientRect();
    var left = rect.left;
    var bottom = rect.bottom;
    return 'display: block; top: ' + bottom + 'px; left: ' + left + 'px;';
  }
  return 'display: none;';
};

this.handleUpKey = function (e) {
  e.preventDefault();
  _this.incrementSelectedResult(-1);
  _this.update();
};
this.handleDownKey = function (e) {
  e.preventDefault();
  _this.incrementSelectedResult(1);
  _this.update();
};
this.updateResults = function (query) {
  _this.reposition();
  if (query) {
    // get nodes that match the entered title,excluding existing point nodes
    _this.autocompleteResults = _searchUi.searchUI.titleSearch(query).filter(function (n) {
      return !Boolean(_perspectivesUi.pui.getPerspectiveFromPointNode(n.id));
    });
    if (_this.autocompleteResults.length > 6) {
      _this.autocompleteResults.splice(6);
    }
  } else {
    _this.autocompleteResults = [];
  }
  _this.update();
};
this.handleMouseoverResult = function (selection, index) {
  _this.selectedItem = index;
  _perspectiveCreationUi.pcui.highlightSelectedResultNode(_this.getSelectedResult());
  _this.update();
};

this.handleMouseleaveResult = function () {
  _perspectiveCreationUi.pcui.clearSelectedResultNode();
  _this.selectedItem = -1;
  _this.update();
};

this.handleUpdatePerspectivePoint = function (e) {
  e.preventDefault();
  e.stopPropagation();
  var selectedNode = _this.getSelectedResult();
  if (!selectedNode) {
    return;
  }
  var title = selectedNode.title;
  var pointNodeUUID = selectedNode.id;
  _this.spawnedFromElement.innerText = title;
  _perspectivesUi.pui.editPerspectivePoint({
    perspective: _this.perspective,
    pointNodeUUID: pointNodeUUID,
    title: title
  });
  _this.refreshAffectedElements(pointNodeUUID, _this.perspective);
  _this.callback();
  _this.hide();
};

this.refreshAffectedElements = function (pointNodeUUID, perspective) {
  _perspectiveCreationUi.pcui.clearSelectedResultNode();
  _perspectivesUi.pui.refreshPerspectiveLists();
  _this.canvas.nodeTags[pointNodeUUID].freshenEyeball();
  if (_perspectivesUi.pui.perspectiveIsActive(_this.perspective.id)) {
    _this.canvas.nodeTags[pointNodeUUID].refreshPerspectiveHighlight();
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('new-perspective-autocomplete')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/new-perspective-autocomplete.html
// module id = 661
// module chunks = 0